import { values } from "lodash";
import ReducersIndex from "reduxModules/ducks";
import { isInside } from "utilities/geometric";

const actions = {
  floorplan: {
    container: ['measure', 'ghostdock'],
  },
  acoustics: {
    container: ['measure', 'position', 'level'],
    area: ['measure', 'position', 'level']
  },
  designpriority: {
    area: ['measure', 'position', 'level', 'remove']
  },
  speakers: {
    container: ['measure', 'position', 'level'],
    area: ['measure', 'position', 'level']
  },
  equipmentlist: {}
};

export const conditions = {
  position: { parameter: ['coverage', 'activeTab'], check: ([coverage, activeTab]) => activeTab === '_warehouse' || !coverage.none },
  level: { parameter: ['coverage', 'activeTab'], check: ([coverage, activeTab]) => activeTab === '_warehouse' || !coverage.none },
  remove: { parameter: ['coverage'], check: ([coverage]) => !coverage.none}
};

export const actionDispatchers = {
  /**
   * Dispatcher for the measure action.
   * Placeholder implementation for measuring distances.
   */
  measure: (evt, dispatch, mouse, drawingBox, device) => {
    console.log('Measure tool activated');
    // TODO: Implement measure functionality
  },

  /**
   * Dispatcher for the position action.
   * Shows positioning information for selected devices.
   */
  position: (evt, dispatch, mouse, drawingBox, device) => {
    console.log('Position info tool activated');
    // TODO: Implement position info display
  },

  /**
   * Dispatcher for the level action.
   * Shows audio level information for speakers.
   */
  level: (evt, dispatch, mouse, drawingBox, device) => {
    console.log('Level info tool activated');
    // TODO: Implement level info display
  },

  ghostdock: (_, dispatch, mouse, drawingBox) => {
    const target = document.getElementById('loadingdocks');
    const {x,y } = mouse;
    const {svgbox: {top, left}} = drawingBox;
    const point = [x + left, y + top];
    const dock = Array.from(target.children).find(child => isInside(point , child.getBoundingClientRect()));
    if (dock) dispatch(ReducersIndex.container.setGhostDocks(dock.id));
  },
  remove: (evt, dispatch) => {
    const target = evt.target.closest('[class=speakers]')?.id;
    if (target) {
      const [area, _, speakerId] = target.split('-');
      dispatch(ReducersIndex.container.deleteSpeaker({area: area, id: speakerId}));
    };
  },
};

export default actions;
